import './SuggestionButton.scss';
import classNames from 'classnames';
import { SparkleIcon } from './SparkleIcon';
import { AUTODOC_TYPE_LABELS } from '@sonar-software/sonar-core';
import { Button, Tooltip } from 'antd';
import React, { useCallback } from 'react';
export const SuggestionButton = ({ className, onClick, placement = 'bottom', autodocType }) => {
    const tooltip = `Suggest ${AUTODOC_TYPE_LABELS[autodocType]}`;
    const handleClick = useCallback((e) => {
        e.stopPropagation();
        onClick();
    }, [onClick]);
    return (React.createElement("div", { className: classNames('suggestion-button', className) },
        React.createElement(Tooltip, { mouseEnterDelay: 0.5, placement: placement, title: tooltip },
            React.createElement(Button, { icon: React.createElement(SparkleIcon, null), onClick: handleClick, tabIndex: -1 }))));
};
